import { useEffect, useState } from "react";
import TagsInput from "react-tagsinput";
import { useFormik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../axiosInterceptor";
import { AttributeInput } from "../../../Components/AttributeInputType";
import {fetchAllData,transformAttributeData} from "../../../helper/ProductAttributeHandling";
import { Sizemultiselect } from "../../../Components/Labels";
import { catlogschema } from "../../../Schema/Schema";
import { toast } from "react-toastify";
import {
  populateAssociations,
  populateAttributes,
  populateBasicFields,
} from "./components/initialdatashow";
import ProductListPreview from "./components/ProductListPreview";
import Upload from "../../../Components/upload";
import CodeEditor from "../../../Components/CodeEditor";

const AddCatalogue = () => {
  const navigator = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const editdata = location.state;
  const [sizedata, setsizedata] = useState([]);
  const [keywords, setkeywords] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [attributeDefaultData, setattributeDefaultData] = useState([]);
  const [updateData, setupdateData] = useState({});
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const requests = [
          fetchAllData(`/category`, setCategoryData),
          fetchAllData(
            "/attribute-children",
            setattributeDefaultData,
          ),
          fetchAllData("/size", setsizedata),
        
        ];

        if (editdata?.catlogId) {
          requests.push(
            fetchAllData(`/catalogue-detail/${editdata.catlogId}`, setupdateData)
          );
        }

        await Promise.all(requests);
        if (id) {
          setFieldValue("category_id", [id]);
        }
      } catch (err) {
        return err
      }
    };

    loadInitialData();
  }, [editdata, id]);

  const initialValues = {
    fullcatalogue: true,
    selection: false,
    name: "",
    cat_code: "",
    offer_price: 0,
    no_of_product: 0,
    price: 0,
    GST: 0,
    catalogue_discount: 0,
    average_price: 0,
    quantity: 0,
    collection_id: [],
    sizes: [],
    homeSectionId: [],
    weight: 0,
    meta_title: "",
    meta_keyword: "",
    meta_description: "",
    description: "",
    tag: [],
    coverImage: null,
    attributes: [],
    optionType: "Stitching",
    brandIds: [],
    category_id: [],
    postId: null,
  };




  const callbackFunc = () => {
    fetchAllData(`/catalogue-detail/${editdata.catlogId}`, setupdateData)
  }
  const {
    errors,
    values,
    handleSubmit,
    handleChange,
    setFieldValue,
    touched,
    handleBlur,
    setFieldTouched,
    setFieldError,
    isSubmitting
  } = useFormik({
    initialValues,
    validationSchema: catlogschema,
    onSubmit: async (values) => {
      try {
        const formattedAttributes = transformAttributeData(selectedValues);
        values.attributes = formattedAttributes;

        if (values.optionType === "Stitching" || values.optionType === "Other") {
          delete values.sizes
        }
        const response = updateData?.id
          ? await axiosInstance.put(`catalogue/${updateData?.id}`, values)
          : await axiosInstance.post("catalogue", values);
        if (response.status === 200) {
          const { data, message } = response.data
          toast.success(message);
          navigator(`/add-catalogue-product`, {
            state: {
              id: data?.id,
              noOfproduct: data.no_of_product,
              average_price: data.average_price,
              selection: data.selection,
              fullset: data.fullcatalogueue,
              categoriesId: values.category_id,
              optionType: data.optionType,
              selctedsize: values.sizes,
              brand_id: values.brandIds,
              category_id:id,
              collection_id: values.collection_id,
              homeSectionId: values.homeSectionId,
            },
          });
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
        return error;
      }

    },
  });

  useEffect(() => {
    if (updateData && Object.keys(updateData).length > 0) {
      populateBasicFields(updateData, setFieldValue);
      populateAssociations(updateData, setFieldValue, setkeywords);
      populateAttributes(updateData?.attributeValues, setSelectedValues);
    }
  }, [updateData]);
  const calculateOfferPrice = () => {
    const coatlogPrice = parseFloat(values.price) || 0;
    const discount = parseFloat(values.catalogue_discount) || 0;
    const offerPrice = (coatlogPrice - coatlogPrice * (discount / 100)).toFixed(
      2
    );

    let noOfproduct = Number(values.no_of_product) || 0;
    const newAveragePrice = noOfproduct
      ? (parseFloat(offerPrice) / noOfproduct).toFixed(2)
      : 0;
    setFieldValue("average_price", newAveragePrice || 0);
    setFieldValue("offer_price", offerPrice || 0);
  };
  useEffect(() => {
    calculateOfferPrice();
  }, [values.price, values.catalogue_discount, values?.offer_price]);
  const customHandleChange = (e, isFromStockUpdate = false) => {
    const { name, value } = e.target;
    const maxProducts = 50;
    setFieldTouched(name, true);
    setFieldValue(name, value);

    if (name === "price") {
      setFieldValue("offer_price", value);
    }
    setFieldValue(name, value);
    if (name === "no_of_product") {
      if (value > maxProducts) {
        setFieldError("no_of_product", "Maximum 50 products are allowed");
        return;
      }

      if (value && values.price) {
        const newAveragePrice = (
          parseFloat(values.offer_price) / parseInt(value)
        ).toFixed(2);
        setFieldValue("average_price", newAveragePrice || 0);
      }

    }

    if (name === "price") {
      if (value && values.no_of_product) {
        const newAvgPrice = (
          parseFloat(value) / parseInt(values.no_of_product)
        ).toFixed(2);
        setFieldValue("average_price", newAvgPrice || 0);
      }
    }
  };
  const handleCategoryChange = (id) => {
    const selectedCategories = values.category_id;
    if (selectedCategories.includes(id)) {
      setFieldValue(
        "category_id",
        selectedCategories.filter((catId) => catId !== id)
      );
    } else {
      setFieldValue("category_id", [...selectedCategories, id]);
    }
  };
  const handleInputChange = (key, value) => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };



  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
        <h3 className="page-title">
  {updateData && Object.keys(updateData).length > 0 ? "Update" : "Add"} Catalogue
</h3>

        </div>
        <div className="row  grid-margin stretch-card">
          <div className="col-md-12">
            <form onSubmit={handleSubmit}>
              <div className="row grid ">
                <div className="col-lg-8">
                  <div className=" rounded bg-white px-4 pt-4 pb-2 mb-3 shadow-s">
                    <div className="row g-0 mr-2">
                      <div className="col-lg-12 col-sm-12">
                        <div className="form-group d-flex">
                          <label className="col-form-label  mr-1">Catalogue Type:</label>
                          <div className="d-flex mx-2" style={{marginTop:"-5px"}}>
                            <div className="form-check mx-4">
                              <input
                                className="form-check-input"
                                id="fullcatalogue"
                                type="checkbox"
                                name="fullcatalogue"
                                checked={values.fullcatalogue}
                                onChange={handleChange}
                              />
                              <label className="form-check-label ml-0" htmlFor="fullcatalogue">
                                Full Catalog
                              </label>
                            </div>
                            <div className="form-check mx-5">
                              <input
                                className="form-check-input mt-1 "
                                id="selection"
                                type="checkbox"
                                name="selection"
                                checked={values.selection}
                                onChange={handleChange}
                              />
                              <label className="form-check-label  ml-0" htmlFor="selection">
                                selection
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label  ">Name</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            id="name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Enter name"
                          />
                          {touched.name && errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">SKU</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            id="cat_code"
                            name="cat_code"
                            value={values.cat_code}
                            onChange={handleChange}
                            placeholder="Enter code"
                          />
                          {touched.cat_code && errors.cat_code && (
                            <small className="text-danger">{errors.cat_code}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label ">No. of Products</label>
                          <input
                            type="number"
                            className="form-control form-control-sm border border-dark"
                            id="no_of_product"
                            name="no_of_product"
                            value={values.no_of_product}
                            onChange={(event) => {
                              customHandleChange(event);
                            }}
                            placeholder="Enter number of products"
                          />
                          {touched.no_of_product && errors.no_of_product && (
                            <small className="text-danger">{errors.no_of_product}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label ">Price</label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control form-control-sm border border-dark"
                              id="price"
                              name="price"
                              value={values.price}
                              onChange={(event) => {
                                customHandleChange(event);
                              }}
                              placeholder="Enter catalog price"
                            />
                          </div>

                          {touched.price && errors.price && (
                            <small className="text-danger">{errors.price}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label ">Discount</label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control form-control-sm border border-dark"
                              id="catalogue_discount"
                              name="catalogue_discount"
                              value={values.catalogue_discount}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Enter catalog discount"
                            />
                            {touched.catalogue_discount && errors.catalogue_discount && (
                              <small className="text-danger">
                                {errors.catalogue_discount}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label ">Catalog Avg. Price</label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control form-control-sm border border-dark"
                              id="average_price"
                              name="average_price"
                              value={values.average_price}
                              readOnly
                              placeholder="Average catalog price"
                            />
                          </div>

                          {touched.average_price && errors.average_price && (
                            <small className="text-danger">{errors.average_price}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label ">offer Price</label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control form-control-sm border border-dark"
                              id="offer_price"
                              name="offer_price"
                              value={values.offer_price}
                              onChange={handleChange}
                              placeholder="Enter catalog discount"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="col-form-label ">Weight</label>
                          <div className="input-group">
                            <input
                              className="form-control form-control-sm border border-dark"
                              type="number"
                              id="weight"
                              name="weight"
                              value={values.weight}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              aria-describedby="basic-addon1"
                            />
                          </div>

                          {touched.weight && errors.weight && (
                            <small className="text-danger">{errors.weight}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label ">Pices</label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control form-control-sm border border-dark"
                              id="quantity"
                              name="quantity"
                              value={values.quantity}
                              onChange={handleChange}
                              //  disabled={values.selection}
                              onBlur={handleBlur}
                              placeholder="Enter catalog discount"
                            />
                          </div>
                          {touched.quantity && errors.quantity && (
                            <small className="text-danger">{errors.quantity}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="col-form-label ">GST Percentage</label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control border border-dark"
                              placeholder="GST percentage"
                              aria-label="GST"
                              value={values?.GST}
                              name="GST"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              aria-describedby="basic-addon1"
                            />

                            {touched.GST && errors.GST && (
                              <small className="text-danger">{errors.GST}</small>
                            )}
                          </div>
                        </div>
                      </div>

                     

                      <div className="col-sm-4">
                         <div className="form-group">
                          <label className="col-form-label ">Instagram Post Id</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            id="postId"
                            name="postId"
                            value={values.postId}
                            onChange={handleChange}
                           placeholder="Enter Post Id"
                          />

                          {touched.postId && errors.postId && (
                            <small className="text-danger">{errors.postId}</small>
                          )}
                        </div>
                      </div>


 <div className="col-sm-6">
                        <div className="form-group">
                          <label className="col-form-label ">Meta Title</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            id="meta_title"
                            name="meta_title"
                            value={values.meta_title}
                            onChange={handleChange}
                            placeholder="Enter meta title"
                          />

                          {touched.meta_title && errors.meta_title && (
                            <small className="text-danger">{errors.meta_title}</small>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="col-form-label ">Meta Keyword</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            id="meta_keyword"
                            name="meta_keyword"
                            value={values?.meta_keyword}
                            onChange={handleChange}
                            placeholder="Enter meta title"
                          />

                          {touched.meta_keyword && errors.meta_keyword && (
                            <small className="text-danger">{errors.meta_keyword}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label className="col-form-label ">Meta Description</label>
                          <textarea
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            id="meta_description"
                            name="meta_description"
                            value={values.meta_description}
                            onChange={handleChange}
                            placeholder="Enter meta description"
                          />

                          {touched.meta_description && errors.meta_description && (
                            <small className="text-danger">{errors.meta_description}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label className="col-form-label ">Description</label>
                          <CodeEditor
                            placeholder="Enter catalogue description..."
                            value={values.description}
                            onChange={(val) => setFieldValue("description", val)}
                          />
                          {touched.description && errors.description && (
                            <small className="text-danger">{errors.description}</small>
                          )}
                        </div>
                      </div>

 <div className="col-sm-12">
                      <div className="form-group">
                        <label className="col-form-label ">cover Image</label>

                        <Upload
                          label="catalogue-image"
                          initialImage={values.coverImage}
                          onChange={(imgUrl) => setFieldValue("coverImage", imgUrl)}
                          apiUrl={"uploads?label=catalogue"}
                        />

                        {touched.coverImage && errors.coverImage && (
                          <small className="text-danger">{errors.coverImage}</small>
                        )}
                      </div>


                    </div>

                   


                      <label>Search Keywords</label>
                      <div className="col-lg-12 col-md-12 col-sm-12 keyword-container">
                        {keywords &&
                          keywords?.length > 0 &&
                          keywords.map((keyword, index) => (
                            <span key={index} className="keyword-badge">
                              {keyword}
                            </span>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="row rounded bg-white px-4 pt-4 pb-2 mb-3 shadow-s">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label className="col-form-label ">Select Categories</label>
                        <div className="scroll-hide pd-20 col-xs-12">
                          <ul className="">
                            {categoryData &&
                              categoryData.length > 0 &&
                              categoryData.map((item, index) => {
                                return (
                                  <li className="list-unstyled" key={item.id}>
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id={`category-${item.id}`}
                                        name="category_id"
                                        value={item.id}
                                        checked={values.category_id.includes(item.id)}
                                        onChange={() => handleCategoryChange(item.id)}
                                      />
                                      <label
                                        className="custom-control-label mx-2"
                                        htmlFor={`category-${item.id}`}
                                      >
                                        {item.name}
                                      </label>
                                    </div>

                                    <ul className="mx-2">
                                      {item.children &&
                                        item.children.length > 0 &&
                                        item.children.map((child, childindex) => (
                                          <li className="list-unstyled" key={child.id}>
                                            <div className="custom-control custom-checkbox">
                                              <input
                                                className="custom-control-input"
                                                type="checkbox"
                                                id={`category-${child.id}`}
                                                name="category_id"
                                                value={child.id}
                                                checked={values.category_id.includes(child.id)}
                                                onChange={() => handleCategoryChange(child.id)}
                                              />
                                              <label
                                                className="custom-control-label mx-2 text-nowrap"
                                                htmlFor={`category-${child.id}`}
                                              >
                                                {child.name}
                                              </label>
                                            </div>
                                          </li>
                                        ))}
                                    </ul>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </div>
                    </div>           
                    <div className="col-sm-12 mt-4">
                      <div className="custom-control custom-radio">
                        <input
                          type="radio"
                          id="radioStitching"
                          name="optionType"
                          className="custom-control-input"
                          value="Stitching"
                          checked={values.optionType === "Stitching"}
                          onChange={handleChange}
                        />
                        <label className="custom-control-label " htmlFor="radioStitching">
                          Stitching
                        </label>
                      </div>

                      <div className="custom-control custom-radio mt-3">
                        <input
                          type="radio"
                          id="radioSizes"
                          name="optionType"
                          className="custom-control-input"
                          value="Size"
                          checked={values.optionType === "Size"}
                          onChange={handleChange}
                        />
                        <label className="custom-control-label " htmlFor="radioSizes">
                          Sizes
                        </label>
                      </div>

                      <div className="custom-control custom-radio mt-3">
                        <input
                          type="radio"
                          id="radioOther"
                          name="optionType"
                          className="custom-control-input"
                          value="Other"
                          checked={values.optionType === "Other"}
                          onChange={handleChange}
                        />
                        <label className="custom-control-label " htmlFor="radioOther">
                          Other
                        </label>
                      </div>
                    </div>

                    {attributeDefaultData &&
                      attributeDefaultData.length > 0 &&
                      attributeDefaultData.map((attribute,index) => (
                        <div className="col-lg-12 col-md-12 col-sm-12" key={index}>
                          {
                            attribute?.showInCatalogue && (
                          <div className="form-group">
                            <label className="col-form-label  ">{attribute?.name}</label>
                            <AttributeInput
                              attribute={attribute}
                              selectedValues={selectedValues || ""}
                              handleInputChange={handleInputChange}
                            />
                          </div>

                            )
                          }
                        </div>
                      ))}
                    {values.optionType === "Size" && sizedata && sizedata?.length > 0 && (
                      <>
                        <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                          <div className="form-group">
                            <Sizemultiselect
                              sizedata={sizedata}
                              values={values?.sizes}
                              touched={touched}
                              setFieldValue={setFieldValue}
                              sizeErrors={errors.sizes}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="form-group">
                        <label className="col-form-label ">Tags</label>
                        <TagsInput
                          value={values.tag}
                          onChange={(newTags) => setFieldValue("tag", newTags)}
                        />

                        {touched.tag && errors.tag && (
                          <small className="text-danger">{errors.tag}</small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-100 d-flex justify-content-center align-items-center gap-3 mt-4 mb-4">
                  <button
                    type="button"
                    onClick={() => {
                      navigator(-1);
                    }}
                    className="btn btn-danger mr-3"
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm mr-2" role="status" />
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>

              </div>
            </form>
          </div>


          {
            updateData.Product && (
              <ProductListPreview
                products={updateData.Product}
                callbackFunc={callbackFunc}
                combinedattributeData={attributeDefaultData}
                catalogue_id={updateData.id}
                catalogueData={values}

              />
            )
          }

        </div>
      </div>
    </>
  );
};

export default AddCatalogue;
